import { useEffect } from "react";

import QRCode from "qrcode.react";
import { useHistory, useLocation } from "react-router-dom";

import { publicPath } from "@ip-utils";
import { trackEvent } from "@ip-utils";
import { ButtonWithLoadingIcon } from "@ip-widgets/Tailwind/common/button";
import component from "@ip-widgets/Tailwind/mfa/styled-components";

export default function PushEnrollment() {
  const history = useHistory();

  const query = new URLSearchParams(useLocation().search);
  const oob_code = query.get("oob_code");
  const barcode_uri = query.get("barcode_uri");
  const base_url = query.get("base_url");
  const _url = `${barcode_uri}&base_url=${base_url}`;

  useEffect(() => {
    function setIsEnrollingToFalse(e: any) {
      trackEvent("MFA", "Cancel enrollment");
      localStorage.setItem("isEnrolling", "false");
    }

    window.addEventListener("beforeunload", setIsEnrollingToFalse);

    return () =>
      window.removeEventListener("beforeunload", setIsEnrollingToFalse);
  }, []);

  useEffect(() => {
    function setIsEnrollingToFalse(e: any) {
      trackEvent("MFA", "Cancel enrollment");
      localStorage.setItem("isEnrolling", "false");
    }

    window.addEventListener("popstate", setIsEnrollingToFalse);

    return () => window.removeEventListener("popstate", setIsEnrollingToFalse);
  }, []);

  const cancelEnrollment = () => {
    trackEvent("MFA", "Cancel enrollment");

    localStorage.setItem("isEnrolling", "false");

    history.push("/security");
  };

  const backToSetting = () => {
    trackEvent("MFA", "Successful enrollment");

    localStorage.setItem("isEnrolling", "false");

    history.push("/security");
  };

  if (!barcode_uri || !oob_code) {
    return <div>Loading</div>;
  }
  return (
    <component.SPage>
      <component.SContainer>
        <component.SHeaderContainer>
          <component.SImage src={publicPath("/media/iglu-white.svg")} />
        </component.SHeaderContainer>
        <component.SBodyContainer>
          <component.SHeader>Secure Your Account</component.SHeader>
          <component.SDescription>
            In order to continue, install the Auth0 Guardian app via the app
            store from your mobile device.
            <br />
            <a
              href="https://itunes.apple.com/us/app/auth0-guardian/id1093447833"
              target="_blank"
              rel="noopener external noreferrer"
            >
              <component.SStoreButton
                src={publicPath("/media/app_store.svg")}
              />
            </a>
            <a
              href="https://play.google.com/store/apps/details?id=com.auth0.guardian"
              target="_blank"
              rel="noopener external noreferrer"
            >
              <component.SStoreButton
                src={publicPath("/media/play_store.svg")}
              />
            </a>
            <br />
            Then scan the QR code with your Auth0 Guardian app and enter your
            generated One-time Password.
          </component.SDescription>

          <component.SQRContainer>
            <QRCode value={_url} renderAs="svg" level="Q" size={146} />
          </component.SQRContainer>

          <ButtonWithLoadingIcon
            text="Complete"
            size="lg"
            onClick={backToSetting}
            style={{ width: "100%", marginTop: 24 }}
          />

          <ButtonWithLoadingIcon
            text="Cancel enrollment"
            size="lg"
            onClick={cancelEnrollment}
            style={{ width: "100%", marginTop: 24, background: "#DC2626" }}
          />
        </component.SBodyContainer>
      </component.SContainer>
    </component.SPage>
  );
}
